import type { BulkImportItem } from "./types";

export function parseBulkImportItems(rawText: string): BulkImportItem[] {
  const parsed = JSON.parse(rawText);
  const items = Array.isArray(parsed) ? parsed : Array.isArray(parsed?.articles) ? parsed.articles : null;
  if (!items) {
    throw new Error("Bulk import JSON must be an array or an object with an articles array.");
  }

  return items.map((item: any, index: number) => {
    const title = typeof item?.title === "string" ? item.title.trim() : "";
    const chunkBody = Array.isArray(item?.chunks)
      ? item.chunks
          .map((chunk: any, chunkIndex: number) => ({
            index: Number.isFinite(Number(chunk?.index)) ? Number(chunk.index) : chunkIndex,
            text: typeof chunk?.text === "string" ? chunk.text.trim() : "",
          }))
          .filter((chunk: { index: number; text: string }) => chunk.text)
          .sort((a: { index: number; text: string }, b: { index: number; text: string }) => a.index - b.index)
          .map((chunk: { index: number; text: string }) => chunk.text)
          .join("\n\n")
      : "";
    const content = typeof item?.content === "string"
      ? item.content
      : typeof item?.body === "string"
        ? item.body
        : typeof item?.body_markdown === "string"
          ? item.body_markdown
        : chunkBody;
    if (!title) throw new Error(`Import item ${index + 1} is missing a title.`);
    if (!content.trim()) throw new Error(`Import item ${index + 1} is missing content/body.`);
    return {
      ...item,
      content,
    } as BulkImportItem;
  });
}
